import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=20ca16f2&scoped=true&"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=20ca16f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca16f2",
  null
  
)

export default component.exports